import * as currency from "currency.js";
export function USD(value) {
    //@ts-ignore
    return currency(value);
}
//Returns a typesafe URLSearchParams from inputted form
export function collateFormData(form) {
    const convertedFormEntries = Array.from(new FormData(form), ([key, value]) => ([key, typeof value === "string" ? value : value.name]));
    return new URLSearchParams(convertedFormEntries);
}
